import Vue from 'vue';
import Vuex from 'vuex';
import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';
import {abilityPlugin} from './ability'

Vue.use(Vuex);

export const store = new Vuex.Store({
  plugins: [abilityPlugin],
  state,
  getters,
  mutations,
  actions
});



// WEBPACK FOOTER //
// ./src/store/store.js